import { all, getContext, put, takeLatest } from 'redux-saga/effects';
import { Logger } from 'utils/Logger';
import Case from 'models/Case';
import { List } from 'immutable';
import { requestLatestCasesFailure, requestLatestCasesSuccess } from './actions';
import { latestCases } from './types';

const logger = new Logger('Saga:Dashboard');

export function* getLatestCases() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield authApiService.get(routerService.generate('api.platform.cases_latest'));

    logger.info('Got new cases summary');
    yield put(requestLatestCasesSuccess(new List(response.data).map((o) => Case.deserialize(o))));
  } catch (error) {
    logger.error(error);
    yield put(requestLatestCasesFailure(error));
  }
}

export default function* latestCasesSaga() {
  return yield all([takeLatest(latestCases.request, getLatestCases)]);
}
